export const color = {
    primary: {
        50: '#F0F8EC',
        100: '#E9F5E4',
        200: '#E0F0D8',
        300: '#D3E9C7',
        400: '#C0DFAF',
        500: '#A5D18C',
        600: '#7FBD5B',
        700: '#54982D',
        800: '#356D14',
        900: '#1F4A06'
    },
    secondary: {
        50: '#EBF1E9',
        100: '#E2EBE0',
        200: '#D5E2D3',
        300: '#C3D5C0',
        400: '#AAC3A5',
        500: '#86AA7E',
        600: '#528547',
        700: '#316327',
        800: '#1C4613',
        900: '#0E2C07'
    },
    background: {
        50: '#F5F5F5',
        100: '#EEF0F0',
        200: '#E7E9E9',
        300: '#DCE0DF',
        400: '#C7CFCC',
        500: '#AFBAB6',
        600: '#8D9C97',
        700: '#71837D',
        800: '#4D645D',
        900: '#203D35',
        950: '#1A362F'
    },
    grey: {
        50: '#FBFBFB',
        100: '#F7F7F7',
        200: '#EEEEEE',
        300: '#E3E3E3',
        400: '#D0D1D1',
        500: '#B0B3B3',
        600: '#8E9293',
        700: '#5D6365',
        800: '#343C3E',
        900: '#010B0E'
    },
    success: {
        50: '#EFFCEE',
        100: '#E5FAE3',
        200: '#D3F6D0',
        300: '#B5F0B0',
        400: '#84E67C',
        500: '#50DB44',
        600: '#30BD23',
        700: '#1B9C10',
        800: '#0D7604',
        900: '#0A6402'
    },
    error: {
        50: '#FFF0EF',
        100: '#FFD9D8',
        200: '#FFCCCA',
        300: '#FDA7A3',
        400: '#F37772',
        500: '#DE4C45',
        600: '#C2241D',
        700: '#A50B04',
        800: '#8B0A04',
        900: '#5E0501'
    },
    warning: {
        50: '#F8EFE8',
        100: '#F8E9DE',
        200: '#F8E0CE',
        300: '#F8D1B3',
        400: '#F9B786',
        500: '#FB8C3C',
        600: '#DF6F1E',
        700: '#C2590C',
        800: '#A94903',
        900: '#8B3A00'
    },
    water: {
        50: '#E7F3FF',
        100: '#BDDEFF',
        200: '#92C8FF',
        300: '#67B3FF',
        400: '#3D9EFF',
        500: '#1286FA',
        600: '#0069D1',
        700: '#0054A8',
        800: '#004080',
        900: '#002B57'
    },
    electricity: {
        50: '#FFF9E9',
        100: '#FFECB9',
        200: '#FFDE89',
        300: '#FFD158',
        400: '#FFC428',
        500: '#DDA616',
        600: '#BB8A08',
        700: '#996F00',
        800: '#775600',
        900: '#553E00'
    },
    gas: {
        50: '#F4E7FF',
        100: '#E2BDFF',
        200: '#CF92FF',
        300: '#BC67FF',
        400: '#AA3DFF',
        500: '#9412FA',
        600: '#7500D1',
        700: '#5E00A8',
        800: '#480080',
        900: '#310057'
    },
    gradient: {
        primary: ['#203D35', '#71837D'],
        white: ['#EEF0F0', '#F5F5F5']
    },
    black: '#000000',
    white: '#FFFFFF'
}
